import { Pipe, PipeTransform } from '@angular/core';
import { CommentPluginService } from './comment-plugin.service';

@Pipe({
    name: 'iconType',
    standalone: false
})
export class IconTypePipe implements PipeTransform {
  public icons: any;

  constructor(private service: CommentPluginService) {
    this.icons = this.service.getIcons();
  }

  transform(id: string): any {
    let parsedId = parseInt(id);
    if (!Number.isInteger(parsedId)) {
      parsedId = null;
    }
    return this.service.getValue(parsedId, this.icons);
  }
}
